/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { ComponentListItemDto } from './component-list-item.dto';

export const ComponentListItemMapper = entity<ComponentListItemDto>({
  costUpdated: date(DateFormat.DateTime),
});
